import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const stops = [
  {
    cls: "md:col-span-7",
    img: "https://images.unsplash.com/photo-1665395492464-fa1da74d2e5c?q=80&w=1600&auto=format&fit=crop",
    title: "The Three Sisters",
    location: "Echo Point, Katoomba",
    fact: "The Mountains' most famous silhouette, on Gundungurra country",
    testid: "tour-photo-three-sisters",
  },
  {
    cls: "md:col-span-5",
    img: "https://images.unsplash.com/photo-1634717685624-171d8309ef48?q=80&w=1600&auto=format&fit=crop",
    title: "Wentworth Falls",
    location: "Jamison Valley",
    fact: "Nearly 200 metres of falling water — a guided walk to the best of it",
    testid: "tour-photo-wentworth-falls",
  },
  {
    cls: "md:col-span-5",
    img: "https://images.unsplash.com/photo-1570865034659-a6b5ffa5efd4?q=80&w=1600&auto=format&fit=crop",
    title: "Govetts Leap",
    location: "Blackheath · Grose Valley",
    fact: "Bridal Veil Falls plunging 180 metres into the Grose",
    testid: "tour-photo-govetts-leap",
  },
  {
    cls: "md:col-span-7",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/2013-07-03_Evans_Lookout_01.jpg/1280px-2013-07-03_Evans_Lookout_01.jpg",
    title: "Evans Lookout",
    location: "Blackheath · Grose Valley",
    fact: "The Grand Canyon track's front-row seat over the valley",
    testid: "tour-photo-evans-lookout",
  },
  {
    cls: "md:col-span-12",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Lennox_Bridge%2C_Glenbrook.jpg/1280px-Lennox_Bridge%2C_Glenbrook.jpg",
    title: "Lennox Bridge",
    location: "Mitchells Pass, Glenbrook — 1833",
    fact: "The oldest stone arch bridge on the Australian mainland, still carrying travellers up the Mountains",
    testid: "tour-photo-lennox-bridge",
  },
];

export default function TourShowcase({ onBook }) {
  return (
    <section
      id="tour"
      className="py-32 border-t border-white/10 bg-[#070707]"
      data-testid="tour-showcase-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="mb-16 flex flex-wrap items-end justify-between gap-8"
        >
          <div>
            <p className="text-xs tracking-[0.35em] uppercase text-[#d4af37] mb-6">
              The Full Day Tour
            </p>
            <h2 className="font-serif-lux text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight max-w-2xl">
              One day. Five icons.
            </h2>
          </div>
          <div className="flex flex-col items-start gap-4">
            <p
              className="text-[11px] tracking-[0.25em] uppercase text-[#d4af37]"
              data-testid="tour-showcase-price"
            >
              $550 per person · 12 hours · GST inclusive
            </p>
            <p
              className="text-[11px] tracking-[0.25em] uppercase text-[#888]"
              data-testid="tour-showcase-availability"
            >
              Tuesdays & Thursdays · 4–7 guests
            </p>
            <button
              data-testid="tour-showcase-book-button"
              onClick={() => onBook("full-day-tour")}
              className="group bg-[#d4af37] text-[#050505] px-8 py-4 text-[11px] tracking-[0.25em] uppercase font-medium hover:bg-[#f3c746] transition-colors duration-500 flex items-center gap-3"
            >
              Book the Full Day Tour
              <ArrowRight
                size={14}
                className="group-hover:translate-x-1 transition-transform duration-300"
              />
            </button>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {stops.map((s, i) => (
            <motion.div
              key={s.testid}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: (i % 2) * 0.12 }}
              className={`group relative overflow-hidden border border-white/10 h-[420px] md:h-[520px] max-h-[80vh] ${s.cls}`}
              data-testid={s.testid}
            >
              <img
                src={s.img}
                alt={`${s.title} — ${s.location}`}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1400ms] ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/90 via-[#050505]/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <p className="text-[10px] tracking-[0.35em] uppercase text-[#d4af37] mb-3">
                  {s.location}
                </p>
                <h3 className="font-serif-lux text-2xl sm:text-3xl font-light tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-xs tracking-[0.1em] text-[#aaa]">
                  {s.fact}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
